import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import AssessmentFlow from "@/pages/AssessmentFlow";
import ResultsPage from "@/pages/ResultsPage";
import HandlungsfeldDetail from "@/pages/HandlungsfeldDetail";
import AdminPage from "@/pages/AdminPage";
import AuthPage from "@/pages/AuthPage";
import Dashboard from "@/pages/Dashboard";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";

function App() {
  return (
    <div className="App dark">
      <div className="fenance-noise" aria-hidden="true" />
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<AssessmentFlow />} />
            <Route path="/handlungsfeld/:id" element={<HandlungsfeldDetail />} />
            <Route path="/ergebnis/:id" element={<ResultsPage />} />
            <Route path="/login" element={<AuthPage mode="login" />} />
            <Route path="/registrieren" element={<AuthPage mode="register" />} />
            <Route path="/mein-verlauf" element={<Dashboard />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-right" theme="dark" richColors />
    </div>
  );
}

export default App;
